// EngagementOverTime

import React, { PureComponent } from "react";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";

import moment from "moment-timezone";
import IntervalSelector from "../IntervalSelector";
import html2canvas from "html2canvas";
import NoData from "../NoData/NoData";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import EngagementOverTimeChart from "./EngagementOverTimeChart";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";

import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import * as d3 from "d3";
class DashboardEngagementOverTime extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this.chartEl = React.createRef();
    }

    formatDataCsv(data) {
        let columns = [["Time"], ["Comments"], ["Likes"], ["Shares"], ["Views"], ["Total"]];
        if (data) {
            data.total.forEach((d, i) => {
                columns[0].push(d.x);
                columns[1].push(data.Comments[i].y);
                columns[2].push(data.Likes[i].y);
                columns[3].push(data.Shares[i].y);
                columns[4].push(data.Views[i].y);
                columns[5].push(data.Comments[i].y + data.Likes[i].y + data.Shares[i].y + data.Views[i].y);
            });
        }

        let formatString = "YYYY-MM-DD HH:mm";
        let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
        columns[0] = columns[0].map((d) => (d === "x" ? "x" : moment(d).tz(userTz).format(formatString)));
        // let csvFmt = columns[0].map((col, i) => columns.map((row) => row[i]));
        return columns;
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);

        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });

        !this.props.drilldown_charts &&
            contextMenu
                .append("li")
                .text("View Insights")
                .on("click", () => {
                    // console.log('drilldown')
                    self.handleDrilldownClick(chart);
                    // this.props.showChartsDrilldown(true, "conversationOverTime");
                });
        contextMenu.style("display", "block");
    };

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        d.series.name = JSON.parse(JSON.stringify(d.series.name.replace("comparisionData", ""))).trim();

        // if (d.series.name.toLowerCase() !== "total") newFilter.extras = [{ key: "engagement", value: d.series.name.toLowerCase() }];
        if (d.originalX) {
            d.x = d.originalX;
        }
        let lastComparisonIndex = false;
        lastComparisonIndex = d.index === d.series.points.length - 1 && d.color.endsWith("85");

        newFilter = getViewConversationDuration(
            d,
            newFilter,
            this.props.aggs_val,
            this.props.filters,
            this.props.comparisionData.chartData,
            lastComparisonIndex,
            this.props.comparisonAppliedFilter,
        );
        if (d?.series.name.toLowerCase() == "likes") newFilter.orderBy = "post.engagement_values.like_count";
        else if (d?.series.name.toLowerCase() == "comments") newFilter.orderBy = "post.engagement_values.comment_count";
        else if (d?.series.name.toLowerCase() == "shares") newFilter.orderBy = "post.engagement_values.share_count";
        else if (d?.series.name.toLowerCase() == "views") newFilter.orderBy = "post.engagement_values.view_count";
        // if (d?.series.name.toLowerCase() !== "total") newFilter.extras = [{ key: "engagement", value: d?.series.name.toLowerCase() }];
        // console.log("first",newFilter)
        //newFilter = getViewConversationDuration(d, newFilter, this.props.aggs_val, this.props.filters);
        return newFilter;
    }

    handleContextMenuClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let data = this.formatDataCsv(this.props.data.chartData);

        data[0][0] = "Time";
        if (this.props.comparisionData) {
            let comparisonData = this.formatDataCsv(this.props.comparisionData.chartData);

            comparisonData[0][0] = " Comparison Time";
            comparisonData[1][0] = " Comparison Comments";
            comparisonData[2][0] = " Comparison Likes";
            comparisonData[3][0] = " Comparison Shares";
            comparisonData[4][0] = " Comparison Views";
            comparisonData[5][0] = " Comparison Total";
            data.push(...comparisonData);
        }

        let firstIndLen = data[0].length;
        let lastIndLen = data[data.length - 1].length;

        let length;
        if (firstIndLen > lastIndLen) length = firstIndLen;
        else length = lastIndLen;

        let arr = [];
        for (let i = 0; i < length; i++) {
            arr.push([]);
            for (let j = 0; j < data.length; j++) {
                if (data[j] && data[j][i]) arr[i].push(data[j][i]);
                else arr[i].push(0);
            }
        }

        // arr = arr.filter((v) => {
        //     return v.some((i) => i);
        // });

        downloadCSVData(arr, this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    handleIntervalChange = (val) => {
        this.props.handleIntervalChange(val);
    };

    render() {
        console.log("first", this.props.data);
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="This chart shows the engagement over time for the date range selected.  Depending on the platform, you can view the Likes, Shares, Comments and / or Video views."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {/* {!this.props.isPublic && !this.props.isResearchDashboard && ( */}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {(this.props.isPublic && nodata) || this.props.drilldown_charts ? null : (
                            <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />
                        )}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />}
                        {!nodata && <CustomCheckBox checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} label="Show Grid Lines" />}
                        {/* {!nodata && <CustomCheckBox checked={this.props.maximizeWidgetValue!==null} onClick={this.props.expandFullWidget} label="Expand Widget" />} */}
                        {!nodata && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    {/* <div className="clone-chart menu-option" onClick={this.props.chartComparision}>
                                    <span>Chart Comparision</span>
                                    <CloneIcon />
                                </div> */}
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate engagement-overtime-chart" ref={this.chartEl}>
                        <EngagementOverTimeChart
                            data={JSON.parse(JSON.stringify(this.props.data))}
                            showLegend={this.props.showLegend}
                            showGridLines={this.props.showGridLines}
                            addContextMenuListener={this.addContextMenuListener}
                            widgetContainerRef={this.props.widgetContainerRef}
                            resizedCount={this.props.resizedCount}
                            comparisionData={this.props.comparisionData}
                            legendClick={this.props.legendClick}
                            expandWidget={this.props.expandWidget}

                            // resizedCount={this.props.resizedCount}
                        />
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardEngagementOverTime);
